import { combineReducers } from "redux"
import { courseProgress } from "./courseProgress"

export const studentCourses = combineReducers({
  courseProgress
})
